import { useMemo } from 'react'
import { AppRole, UseRoleReturn } from '../../utils/types/roles/RolesTypes'

export const useAddRole = (appRolesData?: AppRole[]): UseRoleReturn => {
  const applicationList = useMemo(() => appRolesData ?? [], [appRolesData])

  const rolesOptionsList = useMemo(() => {
    const map: Record<string, Array<{ label: string; value: string }>> = {}
    applicationList.forEach((app) => {
      map[app.applicationCode] =
        app.roles?.map((role) => ({
          label: role.roleName,
          value: role.roleCode,
        })) ?? []
    })
    return map
  }, [applicationList])

  // Helper to get application name by its code
  const getAppNameByAppCode = (appCode: string) => {
    return applicationList.find((app) => app.applicationCode === appCode)?.name
  }

  return {
    applicationList,
    rolesOptionsList,
    getAppNameByAppCode,
  }
}
